export const bannerFadeIn = () => {
  const header = document.querySelector(".header");
  const bannerInner = document.querySelector(".banner__inner");
  const scrollArrow = document.querySelector(".scrolldown-animated-arrow");
  if (!header || !bannerInner || !scrollArrow) return;

  scrollArrow.addEventListener("click", () => {
    const fullwidthVideo = document.querySelector("#fullwidth-video");
    if (fullwidthVideo) {
      fullwidthVideo.scrollIntoView({ behavior: "smooth" });
    }
  });

  const loaderShell = document.querySelector(".loader-shell");
  if (!loaderShell) return;

  const gsap = window.gsap;
  if (!gsap) return;

  /** Fonts + window load, then one rAF so layout/paint from other modules settles before fades. */
  function waitForFullPageReady() {
    const fonts =
      document.fonts && typeof document.fonts.ready?.then === "function"
        ? document.fonts.ready.catch(() => {})
        : Promise.resolve();

    return fonts.then(
      () =>
        new Promise((resolve) => {
          if (document.readyState === "complete") {
            requestAnimationFrame(resolve);
          } else {
            window.addEventListener(
              "load",
              () => requestAnimationFrame(resolve),
              { once: true }
            );
          }
        })
    );
  }

  const runSequence = () => {
    gsap.killTweensOf([header, bannerInner, scrollArrow]);
    gsap.set(bannerInner, { opacity: 0 });
    gsap.set(scrollArrow, { opacity: 0 });
    gsap.set(header, { opacity: 0, visibility: "visible" });

    const ease = "power2.out";
    const tl = gsap.timeline();

    tl.to(bannerInner, { opacity: 1, duration: 0.8, ease }, 0)
      .to(scrollArrow, { opacity: 1, duration: 0.6, ease }, ">")
      .to(header, { opacity: 1, duration: 0.6, ease }, "+=0.015");
  };

  waitForFullPageReady().then(runSequence);
};
